import { Slide } from '@mui/material';
import { FC, useCallback } from 'react';
import { useSnapshot } from 'valtio';
import {
  resetJiraTicketForm,
  setValidationObject,
} from '../../../jira/api/jira-api';
import IssueDrawer from '../../common/components/IssueDrawer/IssueDrawer';
import IssueCard from '../../common/components/IssueItem/IssueCard';
import {
  closeIssueModal,
  setLastDrawerHeight,
  setShowCreateJiraTicketDialog,
} from '../store-actions/resolved-issue-store-actions';
import ResolvedIssuesStore from '../stores/resolved-issues-store';
import CreateJiraTicketModalContainer from '../../common/containers/CreateJiraTicketModaContainer';
import { AppPages, navigate } from '../../../common/routing/app-navigator';

const ResolvedIssueDrawerContainer: FC<
  React.PropsWithChildren<ResolvedIssueDrawerContainerProps>
> = ({ className }) => {
  const {
    showCreateJiraTicketDialog,
    selectedIssue,
    loadingIssue,
    lastDrawerHeight,
  } = useSnapshot(ResolvedIssuesStore);

  const onCloseJiraTicketModal = useCallback(() => {
    navigate(AppPages.ResolvedIssues);
    setShowCreateJiraTicketDialog(false);
    resetJiraTicketForm();
    setValidationObject(null);
  }, []);

  if (!selectedIssue) {
    return null;
  }

  return (
    <IssueDrawer
      className={className}
      title={selectedIssue.mainTitle}
      onClose={closeIssueModal}
      loading={loadingIssue}
      defaultHeight={lastDrawerHeight}
      onResizeStop={setLastDrawerHeight}
      actions={[]}
      issueId={selectedIssue.id}>
      <Slide direction='up' in>
        <div>
          <IssueCard issueDetails={selectedIssue} />
          <CreateJiraTicketModalContainer
            selectedIssue={selectedIssue}
            onClose={onCloseJiraTicketModal}
            open={showCreateJiraTicketDialog}
          />
        </div>
      </Slide>
    </IssueDrawer>
  );
};

interface ResolvedIssueDrawerContainerProps {
  className: string;
}

export default ResolvedIssueDrawerContainer;
